import styled from 'styled-components'

import { media } from 'featureSliced/shared/utils/breakpoints'

export const TimeLocationContainer = styled.div`
  margin: 3vw;
  /* margin-top: 15px; */
  margin-bottom: 0px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colour};
  width: calc(100vw - 6vw);
  color: ${({ theme }) => theme.FontColor};

  /* QRM-641: this full-width banner is the phone layout's way of showing the
     pickup context. The web layout carries it in the menu's left column and in
     the checkout summary, so the banner would only duplicate it — and its
     100vw sizing would spill out of whatever column it lands in. The Time and
     Location parts are still used on their own in both places. */
  ${media.web} {
    display: none;
  }
`

export const InnerContainer = styled.div`
  /* Carries its own colour instead of inheriting it from the banner wrapper: the
     wrapper is hidden on the web layout, and without this the text falls through
     to Bootstrap's #212529 — near-black on the dark theme's card (QRM-641). */
  color: ${({ theme }) => theme.FontColor};
  width: 100%;
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-template-rows: 60px;
  /* gap: 3px; */
  &:not(:last-of-type) {
    border-bottom: 1px solid #ffffff40;
    grid-template-rows: 25px 25px;
    height: 50px;
  }
  p {
    font-size: 12px;
    line-height: 14px;
    align-self: start;
  }
  p:first-of-type {
    font-size: 14px;
    align-self: end;
    font-weight: 600;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1 / 2;
  grid-row: 1 / -1;
`

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  grid-column: 2 / -1;
  grid-row: 1 / -1;
  padding-right: 14px;
  p {
    align-self: start !important;
  }
  p:last-of-type {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }
`
